import _ from 'lodash'
import Vue from 'vue'

Vue.filter('truncate', function(value) {
  return _.truncate(value, {
    length: 100,
    separator: /,? +/,
    omission: '...',
  })
})
